import { parseResponse } from "../../utils/common_lib";
import { baseApi } from "../baseApi";
export const carePlanApi = baseApi.injectEndpoints({
   tagTypes: ["CarePlan"],
   endpoints: (builder) => ({
      getCarePlan: builder.query({
         query: (params) => {
            return {
               url: `/ccm/careplan.json`,
               method: "GET",
               params: params,
            };
         },
         transformResponse: (response, meta, arg) => {
            return parseResponse(response);
         },
      }),
      getMedication: builder.query({
         query: (params) => {
            return {
               url: `/prescriptions/ds_medicines.json`,
               method: "GET",
               params: params,
            };
         },
         transformResponse: (response, meta, arg) => {
            return parseResponse(response);
         },
      }),
      getCarePlanProblem: builder.query({
         query: (params) => {
            return {
               url: `/ccm/get_health_conditions.json`,
               method: "GET",
               params: params,
            };
         },
         transformResponse: (response, meta, arg) => {
            return parseResponse(response);
         },
      }),
      getTrackerHistory: builder.query({
         query: (params) => {
            return {
               url: `/trackers/tracker_values.json`,
               method: "GET",
               params: params,
            };
         },
         transformResponse: (response, meta, arg) => {
            return parseResponse(response);
         },
      }),
      printCareplan: builder.query({
         query: (params) => {
            return {
               url: `/ccm/ccm_pdf_summary.json`,
               method: "GET",
               params: params,
            };
         },
         transformResponse: (response, meta, arg) => {
            return parseResponse(response);
         },
      }),
      getEducationData: builder.query({
         query: (params) => {
            return {
               url: `/intervention/educations.json`,
               method: "GET",
               params: params,
            };
         },
         transformResponse: (response, meta, arg) => {
            return parseResponse(response);
         },
      }),
      screeningPreview: builder.mutation({
         query: (body) => {
           return {
             url: `/patient_forms/get_pat_form_html_view.json`,
             method: "POST",
             params: body,
           };
         },
         transformResponse: (response, meta, arg) => response?.response,
       }),
       getVisitFrequencies: builder.query({
         query: (params) => {
           return {
             url: `/ccm/visit_frequency_problems.json`,
             method: "GET",
             params: params,
           };
         },
         transformResponse: (response, meta, arg) => {
           return parseResponse(response);
         },
       }),
      getActivePrograms: builder.query({
         query: (params) => {
            return {
               url: `/patient_program/get_active_programs.json`,
               method: "GET",
               params: params,
            };
         },
         transformResponse: (response, meta, arg) => {
            return parseResponse(response);
         },
      }),
      getCarePlanData: builder.query({
         query: (params) => {
            return {
               url: `/patient_program/get_care_plan_data.json`,
               method: "GET",
               params: params,
            };
         },
         transformResponse: (response, meta, arg) => {
            return parseResponse(response);
         },
      }),
   }),
});

// Export hooks for usage in functional components
export const {
  useGetCarePlanQuery,
  useGetMedicationQuery,
  useGetCarePlanProblemQuery,
  useGetTrackerHistoryQuery,
  usePrintCareplanQuery,
  useGetEducationDataQuery,
  useScreeningPreviewMutation,
  useGetVisitFrequenciesQuery,
  useGetActiveProgramsQuery,
  useGetCarePlanDataQuery,
} = carePlanApi;
